const childrenSortMixin = {
  methods: {
    childrenSort (parent) {
      let component = parent

      if (component.children && component.children.length) {
        // 排序
        if (component.properties.childrenSort && component.properties.childrenSort.length) {
          if (component.properties.childrenSort.length !== component.children.length) {
            throw Error('childrenSort.length !== children.length)')
          }
          component.children.sort((a, b) => component.properties.childrenSort.indexOf(a.id) - component.properties.childrenSort.indexOf(b.id))
        }

        // 递归调用
        component.children.forEach(n => {
          if (n.children && n.children.length) {
            this.childrenSort(n)
          }
        })
      }
    }
  }
}

const heightMixin = {
  methods: {
    initHeight (dom) {
      dom.style.height = this.height
    }
  },
  computed: {
    height () {
      let component = this.component || this.initComponent
      return component.properties.height ? component.properties.height + 'px' : 'inherit'
    }
  }
}

export { childrenSortMixin, heightMixin }



// WEBPACK FOOTER //
// ./src/components/shared/designAndRuntimeMixins/mixins.js